/**
 * Created by vblanco on 12/06/2017.
 */
(function () {
    'use strict';

    angular.module('app')
        .factory('Subgenero', Subgenero);

    /* @ngInject */
    function Subgenero($resource) {
        return $resource('api/admin/subgenero/:id', {}, {
            'query': {
                method: 'GET',
                isArray: true,
                url: 'api/public/subgenero/query'
            },
            'get': {
                method: 'GET',
                url: 'api/public/subgenero/:id'
            },
            'findAll': {
                method: 'GET',
                isArray: false,
                url: 'api/public/subgenero/findAll'
            },
            'findAllTipologias': {
                method: 'GET',
                isArray: false,
                url: 'api/public/tipologia/findAll'
            }
        });
    }
})();
